/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';

import {
  DialogTitle,
  Grid,
  IconButton,
  Dialog,
  TextField,
  Typography,
  Paper,
  FormControlLabel,
  Switch
} from '@material-ui/core';
import axios from 'axios';
import Draggable from 'react-draggable';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import Button from 'components/Button/button';
import CommonAlert from 'components/CommonAlert/CommonAlert';
import CloseIconNavy from 'images/icons/signals/closesAndCancels/closeDialog.svg';
import * as UserActions from 'store/actions/user';
import { Container } from 'styles/general';
import Environment from 'utils/environments';
import history from 'utils/history';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title-storage"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function ProcessForm({
  userInfo,
  processInfo,
  redirectPath,
  isModal,
  onClose,
  setUpdateList,
  selectedItems,
  setSelectedItems,
  jsonBody,
  setJsonBody,
  openModal,
  updateList
}) {
  const restaurantGroups = userInfo.companies.groups
    .reduce((acc, group) => [...acc, group.subGroups], [])
    .flat()
    .reduce((acc, subGroup) => [...acc, subGroup.stores], [])
    .flat()
    .map((el) => el.id);
  const environments = Environment(process.env.REACT_APP_ENV);
  const userLocal = JSON.parse(localStorage.getItem('companies'));
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { handleSubmit } = useForm();
  const [alertErr, setAlertErr] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [statusCode, setStatusCode] = useState();
  const onDismiss = () => setAlertErr(false);
  const [editMode, setEditMode] = useState(
    processInfo?.action?.toLowerCase() === 'edit' || false
  );
  const [producersId, setProducersId] = useState(
    editMode ? processInfo.data.id : ''
  );
  const [description, setDescription] = useState(
    editMode ? processInfo.data.description : ''
  );
  const [activeStatusFilter, setActiveStatusFilter] = useState(
    processInfo?.data?.status === 'INACTIVE' ? false : true || true
  );

  const onSubmitStorageLocation = () => {
    setLoading(true);

    const config = {
      headers: {
        User: `${userLocal?.user}`
      }
    };

    if (editMode) {
      const statusFilterValue = activeStatusFilter ? 'ACTIVE' : 'INACTIVE';
      axios
        .put(
          `${environments.catalog}/processes/${producersId}`,
          {
            description,
            status: statusFilterValue,
            restaurantId: restaurantGroups
          },
          config
        )
        .then((res) => {
          setAlertMessage(res.data.message);
          setStatusCode(res.status);
          setOpen(true);
          setLoading(false);
          setUpdateList && setUpdateList(true);
          onClose &&
            setTimeout(() => {
              onClose();
            }, 1000);
          // const { data } = res
        })
        .catch((error) => {
          setLoading(false);
          setAlertMessage(error?.response?.data?.message);
          setStatusCode(error?.response?.status);
          setAlertErr(true);
          setUpdateList && setUpdateList(false);
        });
    } else {
      const statusFilterValue = activeStatusFilter ? 'ACTIVE' : 'INACTIVE';

      axios
        .post(
          `${environments.catalog}/processes`,
          {
            method: 'POST',
            description,
            status: statusFilterValue,
            restaurantId: restaurantGroups,
            user: userInfo.user
          },
          config
        )
        .then((response) => {
          setOpen(true);
          setLoading(false);
          setAlertMessage(response?.data?.message);
          setStatusCode(response?.status);
          setUpdateList && setUpdateList(true);

          if (isModal && setSelectedItems && setJsonBody) {
            setSelectedItems({
              ...selectedItems,
              product: {
                ...selectedItems?.product,
                storage: [
                  {
                    id: response?.data?.id,
                    description: response?.data?.description
                  }
                ]
              }
            });

            setJsonBody({
              ...jsonBody,
              product: {
                ...jsonBody?.product,
                storage: [
                  {
                    id: response?.data?.id,
                    description: response?.data?.description
                  }
                ]
              }
            });
          }

          onClose &&
            setTimeout(() => {
              onClose();
            }, 1000);
          // const { data } = res
        })
        .catch((error) => {
          setLoading(false);
          setAlertMessage(error?.response?.data?.message);
          setStatusCode(error?.response?.status);
          setAlertErr(true);
          setUpdateList && setUpdateList(false);
        });
    }
  };

  const handleClose = (reason) => {
    if (redirectPath !== null) {
      history.push(redirectPath);
    }

    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <Dialog
      className="defaultModal storageRegisterDialog"
      style={{ width: '50%' }}
      open={openModal}
      // fullWidth={true}
      maxWidth="xl"
      onClose={onClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title-storage"
      transitionDuration={0}
    >
      <Container className="w100" style={{ marginBottom: '0px' }}>
        <DialogTitle
          className="modalHeaderProcess navyBlue bold textAlignCenter cursorMove"
          style={{
            borderRadius: '4px 4px 0 0'
          }}
          id="draggable-dialog-title-storage"
        >
          <Typography>CADASTRO DE PROCESSOS</Typography>

          <IconButton
            edge="start"
            color="inherit"
            onClick={() => {
              onClose();
            }}
            aria-label="close"
            style={{ outline: '0', background: 'none' }}
          >
            <img
              style={{ width: '16px' }}
              src={CloseIconNavy}
              alt="CloseIconNavy"
            />
          </IconButton>
        </DialogTitle>

        {alertErr ? (
          <CommonAlert
            open={alertErr}
            onClose={onDismiss}
            indexMessage={alertMessage}
            statusCode={statusCode}
            width="100%"
          />
        ) : null}

        <div
          className="cardDefault pt16"
          style={{ borderRadius: '0', width: 'auto', minWidth: '550px' }}
        >
          <form onSubmit={handleSubmit(onSubmitStorageLocation)}>
            <Grid className="m0" container xs={12} sm={12} spacing={4}>
              <Grid item xs={12} sm={12} className="pl0 pr0">
                <TextField
                  label="Descrição"
                  onChange={(e) => setDescription(e.target.value.toUpperCase())}
                  name="description"
                  variant="outlined"
                  size="small"
                  value={description}
                  defaultValue={editMode ? processInfo.data.description : null}
                  fullWidth
                  required="required"
                  inputProps={{ maxLength: 50 }}
                  className="textFieldSmall"
                  placeholder="Digite aqui..."
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
            </Grid>
            
            {editMode && (
              <Grid>
                <FormControlLabel
                  className="toggleDefault m0 dFlex"
                  control={
                    <Switch
                      checked={activeStatusFilter}
                      onChange={(checked) => {
                        setActiveStatusFilter(!activeStatusFilter);

                        if (checked) {
                          setCallSettings({
                            ...callSettings,
                            mainContent: [],
                            loading: false
                          });
                        }
                      }}
                      name="Active Status Filter"
                    />
                  }
                  label="Ativo"
                />
              </Grid>
            )}

            <CommonAlert
              open={open}
              onClose={handleClose}
              indexMessage={alertMessage}
              width="100%"
              statusCode={statusCode}
              severity="success"
            />

            <Grid
              item
              xs={12}
              sm={12}
              className="p0 dFlex justifyEnd bgWhite"
              style={{
                borderRadius: '0 0 4px 4px'
              }}
            >
              {!isModal && (
                <Link to="/inventario/locais-de-armazenamento/">
                  <Button
                    className="defaultButton backButton"
                    design="outlined"
                    label="Voltar"
                    style={{ marginRight: '20px' }}
                  />
                </Link>
              )}

              <Button
                className="defaultButton submitButton"
                type="submit"
                label="Salvar"
                design="contained"
                onSubmit={handleSubmit(onSubmitStorageLocation)}
              />
            </Grid>
          </form>
        </div>
      </Container>
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.user,
  processInfo: state.process
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(UserActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProcessForm);
